import { render } from "./KindergartenSpecialStandardView.vue?vue&type=template&id=4286a3cf&scoped=true&ts=true"
import script from "./KindergartenSpecialStandardView.vue?vue&type=script&lang=ts"
export * from "./KindergartenSpecialStandardView.vue?vue&type=script&lang=ts"

import "./KindergartenSpecialStandardView.vue?vue&type=style&index=0&id=4286a3cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4286a3cf"]])

export default __exports__